import { useState } from 'react';
import { useUserState } from '../../hooks/context/useUserState';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import { requestLayoutDefinition } from '../requests/layout/requestLayoutDefinition';
import { LayoutDefinition } from '../../types/types';

export const useLayoutDefinition = (layoutId: string) => {
  const {
    state: { token },
  } = useUserState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [data, setData] = useState<LayoutDefinition | undefined>(undefined);
  const handleApiError = useApiErrorHandling();

  const fetch = async (forceHeader?: string) => {
    try {
      setIsLoading(true);
      setData(undefined);
      setError(undefined);
      const definition = await requestLayoutDefinition(
        layoutId,
        token,
        forceHeader
      );
      setData(definition);
      return definition;
    } catch (e) {
      if (e instanceof Error) setError(e);
      handleApiError(e, true, (retryForceHeader) => fetch(retryForceHeader));
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, data, fetch };
};
